import { Component } from '@angular/core';
import { AuthService } from 'src/app/core/auth.service';
import { CommonModule } from '@angular/common';
import { IdentityService } from 'src/app/core/identity.service';
import { take, tap } from 'rxjs';

@Component({
    selector: 'nova-delegation-restrict-access',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './delegation-restrict-access.component.html',
    styleUrl: './delegation-restrict-access.component.scss'
})
export class DelegationRestrictAccessComponent {
    mainProfileUserName: string = '';
    mainProfileUserId: string = '';
    constructor(
        private readonly _authService: AuthService,
        private readonly _identityService: IdentityService
    ) {
        this._identityService.user$
            .pipe(
                tap((user: { name: string; primary_user_key: string }) => {
                    this.mainProfileUserName = user.name;
                    this.mainProfileUserId = user.primary_user_key;
                }),
                take(1)
            )
            .subscribe();
    }

    switchToMainProfile(mainProfileUserId: string) {
        this._authService.changeProfile(mainProfileUserId);
    }
}
